// components/ErrorBoundary.jsx
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error("❌ Error atrapado en ErrorBoundary:", error, info);
  }

  render() {
    const { hasError, error } = this.state;
    const { debug } = this.props;

    if (hasError) {
      return debug ? (
        <div className="p-6 text-red-600 font-mono bg-red-50 border border-red-200 rounded-md">
          <h2 className="text-lg font-bold mb-2">⛔ Error en componente</h2>
          <pre className="text-sm whitespace-pre-wrap">{error?.message}</pre>
        </div>
      ) : (
        <div className="p-4 text-sm text-red-600 text-center">
          ⚠️ Error al cargar este componente. Intentalo de nuevo más tarde.
        </div>
      );
    }

    return this.props.children;
  }
}
